import { render, staticRenderFns } from "./Phone.vue?vue&type=template&id=3aef9b8c&scoped=true"
import script from "./Phone.vue?vue&type=script&lang=js"
export * from "./Phone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aef9b8c",
  null
  
)

export default component.exports